import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http'
import { Observable } from 'rxjs/Observable'

import { User } from '../../data/models'
import { TokenExpiredError, ApiTokenFactory } from '../../core/models'
import { EnvironmentService } from '../../core/services'
import { AppContext, RedirectHelper } from '../../helpers'
import { UserService } from '../../services'

export class AuthenticationService {

  constructor(
    private _http: HttpClient,
    private _appContext: AppContext,
    private _apiTokenFactory: ApiTokenFactory,
    private _userService: UserService,
    private _redirectHelper: RedirectHelper,
    private _usersApiUrl: string,
    private _environmentService: EnvironmentService
  ) {
    this._usersApiUrl = this._environmentService.get('USERS_API_URL')
  }

  public authenticateWithToken(jwt: string): Observable<boolean> {
    this._appContext.apiToken = this._apiTokenFactory.get(jwt)

    return this._userService.getUser()
      .map((user) => {
        if (user instanceof User) {
          this._appContext.currentUser = user
          this._setTokenExpirationTimeout(
            this._appContext.apiToken.getUnverifiedExpirationTimestamp()
          )
          return true
        } else {
          this._redirectHelper.toLoginPage()
        }
      })
  }

  public logout(): Observable<object> {
    return this._http.get(
      this._usersApiUrl + '/logout',
      this._getHttpOptions()
    ).map((response: HttpResponse<any>) => {
      if (response.ok) {
        this._redirectHelper.toLogoutPage({':testline': this._appContext.apiToken.getIssuingTestline()})
      }
      return response
    })
  }

  private _getHttpOptions() {
    return {
      headers: new HttpHeaders({
        'Content-Type': 'application/vnd.api+json',
        'Accept': 'application/vnd.api+json',
        'mp-auth-token': this._appContext.apiToken.getRawToken()
      }),
      observe: 'response' as 'body',
      responseType: 'json' as 'json',
      withCredentials: true
    }
  }

  private _setTokenExpirationTimeout(tokenExpirationTimestamp: number): void {
    const utcTimestamp = Math.floor((new Date()).getTime() / 1000)
    const timeoutInMs = (tokenExpirationTimestamp - utcTimestamp) * 1000
    setTimeout(() => {
      this.logout().subscribe(() => {
        throw new TokenExpiredError()
      })
    }, timeoutInMs)
  }
}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/services/authentication/authentication.service.ts